import {Space} from "antd";
import {useCreateBundleContext} from "../../context/create-bundle";
import {CreateBundleBasicFormStep} from "../basic-form";
import {CreateBundleCheckoutFormStep} from "../checkout-form";
import {CreateSessionFormStepsMobile} from "../create-bundle-steps";
import {ServiceFormLayout} from "../../../createService/service-form-layout";
import {StyledHideStepOnDesktop} from "../../../../../components/offering-form/general/steps/styles";
import {CreateBundleCoverImagesUploadStep} from "../cover-images-upload";
import {CreateBundleAutomationsStep} from "../automations";
import {DraftResumeBanner} from "../../../../../components/offering-form/general/draft-resume-banner";
import {useDraftResumeBanner} from "../../../../../utils/offering-create-draft";

export function CreateBundleMultiStepForm() {
  const {
    dispatch,
    wasDraftRestored,
    state: {currentCreateBundleStep},
  } = useCreateBundleContext();
  const {formKey, showBanner, handleStartFresh} = useDraftResumeBanner(
    wasDraftRestored,
    dispatch
  );

  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      {showBanner ? <DraftResumeBanner onStartFresh={handleStartFresh} /> : null}
      <StyledHideStepOnDesktop>
        <CreateSessionFormStepsMobile />
      </StyledHideStepOnDesktop>
      <ServiceFormLayout key={formKey}>
        {currentCreateBundleStep === "basicForm" ? (
          <CreateBundleBasicFormStep />
        ) : currentCreateBundleStep === "checkoutForm" ? (
          <CreateBundleCheckoutFormStep />
        ) : currentCreateBundleStep === "coverImagesUpload" ? (
          <CreateBundleCoverImagesUploadStep />
        ) : currentCreateBundleStep === "automations" ? (
          <CreateBundleAutomationsStep />
        ) : null}
      </ServiceFormLayout>
    </Space>
  );
}
